import request from '@/utils/request'
export function getDynamList(city) {
  return request({
    url: 'dynamics/'+city,
    method: 'get',
  })
}




// WEBPACK FOOTER //
// ./src/api/dynamics_api.js